import React from 'react';
import { NavLink } from 'react-router-dom';
import i18n from '../../i18n';
import { getLoggedUser } from '../../state/user';
import { generateMzadcomID } from '../../state/utils';
import {
  LayoutDashboard,
  User,
  Users,
  UsersRound,
  UserPlus,
  CreditCard,
  Wallet,
  Layers,
  List,
  Building2,
  Image,
  Ban,
  Plus,
  Minus,
  CheckCircle,
  Trophy,
  MapPin,
  DollarSign,
  Landmark,
  ThumbsUp,
  Heart,
  FileText,
  Flag,
  Hourglass,
  Key,
  BarChart3,
  Bell,
  TrendingUp,
  PieChart,
  Activity,
  LogOut,
  Gavel,
  ClipboardClock,
  Undo2,
  Truck,
  Forklift,
  Gauge,
  ListPlus,
  WalletMinimal,
  BanknoteArrowDown,
} from 'lucide-react';

const user = getLoggedUser();
let is_logged = localStorage.getItem('is_logged_in') ? true : false;
const allowed_roles = ['CE', 'GM'];

function logout() {
  localStorage.clear();
  window.location.href = '/';
}

export class SideBarMob extends React.Component {
  constructor() {
    super();
    this.state = {
      dashboard_menu_expand: true,
      report_menu_expand: true,
    };
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    document.body.style = '';
  }

  render() {
    let { count } = this.state;
    let lang = localStorage.getItem('I18N_LANGUAGE');
    return (
      <React.Fragment>
        {is_logged && (
          <div>
            <div class="show_mobile">
              <div class="p-1">
                <div class="p-2 user-brd rounded-4">
                  <div class="d-flex">
                    <div class="pe-2">
                      {user.avatar && (
                        <img
                          src={user.avatar}
                          alt="user"
                          className="rounded rounded-lg"
                          referrerPolicy="no-referrer"
                          width={35}
                        />
                      )}
                      {!user.avatar && (
                        <div
                          className="d-flex align-items-center justify-content-center rounded-circle bg-light"
                          style={{ width: 35, height: 35 }}
                        >
                          <User size={20} />
                        </div>
                      )}
                    </div>
                    <div>
                      <div class="fs24 text-black lh28">{user.name}</div>
                      <div class="text-gray fs10">{user.email}</div>
                    </div>
                  </div>
                  <hr class="px-3" />
                  <div
                    class="text-black justify-content-center gap-2 d-flex"
                    style={{ fontSize: '0.5rem' }}
                  >
                    <div class="d-flex gap-1">
                      <span class="text-gray">{i18n.t('mobile')}:</span>
                      <span>{user.mobile}</span>
                    </div>
                    <div class="d-flex gap-1">
                      <span class="text-gray">{i18n.t('mzadcom_id')}:</span>
                      <span>{generateMzadcomID(user.id, user.role)}</span>
                    </div>
                    <div class="d-flex gap-1">
                      <span class="text-gray">{i18n.t('email')}:</span>
                      <span>{user.email}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {user.role === 'U' && (
              <div class="show_mobile mobile-sidebar-offcanvas">
                <div class="mobile-balance-btn-div d-mob-none">
                  <button class="mobile-balance-btn">
                    <Wallet size={16} />
                    <span>
                      {i18n.t('wallet')} : {this.props.wallet_amount} {i18n.t('omr')}{' '}
                    </span>
                  </button>
                </div>
                <div class="mobile-menu-row">
                  {/* Dashboard */}
                  <NavLink activeClassName="active" to="/dashboard" className="mobile-menu-item">
                    <LayoutDashboard size={20} className="mx-3" />
                    {i18n.t('dashboard')}
                  </NavLink>

                  {/* Profile */}
                  <NavLink className="mobile-menu-item" activeClassName="active" to="/profile">
                    <User size={20} />
                    <span>{i18n.t('edit_profile')}</span>
                  </NavLink>

                  {/* My Bids */}
                  <NavLink className="mobile-menu-item" activeClassName="active" to="/my_auctions">
                    <Key size={20} />
                    <span>{i18n.t('my_bids')}</span>
                  </NavLink>

                  {/* Enrolled Auctions */}
                  <NavLink
                    activeClassName="active"
                    to="/enrolled_auctions"
                    className="mobile-menu-item"
                  >
                    <Gavel size={20} />
                    <span>{i18n.t('enrolled_auctions')}</span>
                  </NavLink>

                  {/* Mzadcom Payment */}
                  <NavLink
                    to="/mzadcom-payment"
                    className="mobile-menu-item"
                    activeClassName="active"
                  >
                    <CreditCard size={15} />
                    <span>{i18n.t('mzadcom_payment')}</span>
                  </NavLink>

                  {/* Winning Bids */}
                  <NavLink to="/winning_bids" className="mobile-menu-item" activeClassName="active">
                    <Trophy size={20} />
                    <span>{i18n.t('winning_bids')}</span>
                  </NavLink>

                  {/* Site Visit - all except C, U qualifies */}
                  <NavLink to="/site_visit" className="mobile-menu-item" activeClassName="active">
                    <MapPin size={20} />
                    <span>{i18n.t('site_visit')}</span>
                  </NavLink>

                  {/* Wallet */}
                  <NavLink to="/wallet" className="mobile-menu-item" activeClassName="active">
                    <Wallet size={20} />
                    <span>{i18n.t('my_wallet')}</span>
                  </NavLink>

                  {/* Liked Auctions */}
                  <NavLink
                    to="/auction/liked"
                    className="mobile-menu-item"
                    activeClassName="active"
                  >
                    <ThumbsUp size={15} />
                    <span>{i18n.t('liked_auctions')}</span>
                  </NavLink>

                  {/* Wishlisted Auctions */}
                  <NavLink
                    to="/auction/wishlist"
                    className="mobile-menu-item"
                    activeClassName="active"
                  >
                    <Heart size={15} />
                    <span>{i18n.t('wishlisted_auctions')}</span>
                  </NavLink>
                </div>
              </div>
            )}

            {user.role !== 'U' && (
              <div class="show_mobile">
                <div class="dashboard-bg rounded-4 d-flex justify-content-between align-items-center p-4">
                  <div>
                    <button
                      class="dropbtn"
                      type="button"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasExample"
                      aria-controls="offcanvasExample"
                    >
                      <LayoutDashboard size={20} />
                    </button>

                    <div
                      class="offcanvas offcanvas-start canvas_width"
                      tabindex="-1"
                      id="offcanvasExample"
                      aria-labelledby="offcanvasExampleLabel"
                    >
                      <div class="offcanvas-header dashboard-bg" style={{ height: '8%' }}>
                        <div class="text-center text-black fwb py-3 mb-2 d-flex align-items-center">
                          <LayoutDashboard size={20} className="pe-1 Dashboard_mob_size" />
                          <span class="dashboard_res">{i18n.t('dashboard')}</span>
                        </div>
                        <div>
                          <button
                            type="button"
                            class="btn-close text-reset"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                          ></button>
                        </div>
                      </div>
                      <div class="offcanvas-body">
                        <div className="item1-links  mb-0">
                          {/* Management Dashboard */}
                          {['CE', 'GM'].includes(user.role) && (
                            <NavLink
                              activeClassName="active"
                              to="/management"
                              className="d-flex border-bottom"
                            >
                              <LayoutDashboard size={20} className="mx-1" />
                              {i18n.t('management_dashboard')}
                            </NavLink>
                          )}

                          {/* Cash Flow Dashboard */}
                          {['CE', 'GM', 'F'].includes(user.role) && (
                            <NavLink
                              activeClassName="active"
                              to="/cash-flow"
                              className="d-flex border-bottom"
                            >
                              <span className="icon1 me-3">
                                <BarChart3 size={18} />
                              </span>
                              {i18n.t('mzadcom_cash_flow_dashboard')}
                            </NavLink>
                          )}

                          {/* Dashboard for U/CE/GM (U never hits this branch) */}
                          {['U', 'CE', 'GM'].includes(user.role) && (
                            <NavLink
                              activeClassName="active"
                              to="/dashboard"
                              className="mobile-menu-item"
                            >
                              <LayoutDashboard size={20} className="mx-1" />
                              {i18n.t('dashboard')}
                            </NavLink>
                          )}

                          {/* Loading Progress (CE/GM) */}
                          {(user.role === 'CE' || user.role === 'GM') && (
                            <NavLink
                              activeClassName="active"
                              to="/loading-progress"
                              className="d-flex border-bottom"
                            >
                              <span className="icon1 me-3">
                                <Gauge size={18} />
                              </span>
                              {i18n.t('loading_progress')}
                            </NavLink>
                          )}

                          {/* Client Dashboard */}
                          {['C'].includes(user.role) && (
                            <NavLink
                              activeClassName="active"
                              to="/client-dashboard"
                              className="d-flex border-bottom"
                            >
                              <LayoutDashboard size={20} className="mx-1" />
                              {i18n.t('dashboard')}
                            </NavLink>
                          )}

                          {/* Loading Progress (C) */}
                          {['C'].includes(user.role) && (
                            <NavLink
                              activeClassName="active"
                              to="/loading-progress"
                              className="d-flex border-bottom"
                            >
                              <span className="icon1 me-3">
                                <Gauge size={18} />
                              </span>
                              {i18n.t('loading_progress')}
                            </NavLink>
                          )}

                          {/* Dashboard submenu - excludes U, C, CE, GM, O */}
                          {!['U', 'C', 'CE', 'GM', 'O'].includes(user.role) && (
                            <>
                              <a href={true} className="d-flex border-bottom">
                                <LayoutDashboard size={20} className="mx-1" />
                                {i18n.t('dashboard')}
                              </a>
                              <NavLink
                                activeClassName="active"
                                to="/dashboard"
                                className="d-flex border-bottom"
                              >
                                <Activity size={20} className="mx-3" />
                                {i18n.t('live_dashboard')}
                              </NavLink>
                              <NavLink
                                activeClassName="active"
                                to="/dashboard-auc-eval"
                                className="d-flex border-bottom"
                              >
                                <PieChart size={20} className="mx-3" />
                                {i18n.t('auction_evaluation')}
                              </NavLink>
                              <NavLink
                                activeClassName="active"
                                to="/dashboard-user-analysis"
                                className="d-flex border-bottom"
                              >
                                <Users size={20} className="mx-3" />
                                {i18n.t('user_analysis')}
                              </NavLink>
                              <NavLink
                                activeClassName="active"
                                to="/dashboard-sales-eval"
                                className="d-flex border-bottom"
                              >
                                <TrendingUp size={20} className="mx-3" />
                                {i18n.t('sales_evaluation')}
                              </NavLink>
                            </>
                          )}

                          {/* Profile */}
                          <NavLink
                            activeClassName="active"
                            to="/profile"
                            className="d-flex border-bottom"
                          >
                            <span className="icon1 me-3">
                              <User size={16} />
                            </span>{' '}
                            {i18n.t('edit_profile')}
                          </NavLink>

                          {/* Users */}
                          {['A', 'PM', 'F', 'OM', 'GM', 'CE', 'M'].includes(user.role) && (
                            <NavLink
                              to="/users"
                              activeClassName="active"
                              className="d-flex  border-bottom"
                            >
                              <span className="icon1 me-3">
                                <Users size={16} />
                              </span>{' '}
                              {i18n.t('users')}
                            </NavLink>
                          )}

                          {/* Clients */}
                          {['A', 'PM', 'OM', 'GM', 'CE', 'M'].includes(user.role) && (
                            <NavLink
                              to="/clients"
                              activeClassName="active"
                              className="d-flex  border-bottom"
                            >
                              <span className="icon1 me-3">
                                <UsersRound size={16} />
                              </span>{' '}
                              {i18n.t('clients')}
                            </NavLink>
                          )}

                          {/* Enrolled Users */}
                          {['A', 'PM', 'OM', 'GM', 'CE', 'F', 'M'].includes(user.role) && (
                            <NavLink
                              activeClassName="active"
                              to="/enrolled_users"
                              className="d-flex  border-bottom"
                            >
                              <span className="icon1 me-3">
                                <UserPlus size={16} />
                              </span>{' '}
                              {i18n.t('enrolled_users')}
                            </NavLink>
                          )}

                          {/* Auction Payments */}
                          {['F', 'PM'].includes(user.role) && (
                            <NavLink
                              to="/auction-payment"
                              activeClassName="active"
                              className="d-flex  border-bottom"
                            >
                              <CreditCard size={16} className="me-3" />
                              {i18n.t('auction_payments')}
                            </NavLink>
                          )}

                          {/* Mzadcom Transactions Summary */}
                          {['A', 'F', 'CE', 'GM'].includes(user.role) && (
                            <NavLink
                              to="/mzadcom-transactions-summary"
                              activeClassName="active"
                              className="d-flex  border-bottom"
                            >
                              <Wallet size={16} className="me-3" />
                              {i18n.t('mzadcom')} - {i18n.t('transactions')}
                            </NavLink>
                          )}

                          {/* Recharge / Withdrawal Requests */}
                          {(user.role === 'A' ||
                            user.role === 'F' ||
                            user.role === 'CE' ||
                            user.role === 'GM') && (
                            <div>
                              <NavLink
                                to="/recharge-requests"
                                activeClassName="active"
                                className="d-flex  border-bottom"
                              >
                                <WalletMinimal size={16} className="me-3" />
                                <span className="text-justify">{i18n.t('recharge_requests')}</span>
                              </NavLink>
                              <NavLink
                                to="/withdrawal-requests"
                                activeClassName="active"
                                className="d-flex  border-bottom"
                              >
                                <BanknoteArrowDown size={16} className="me-3" />
                                <span className="text-justify">
                                  {i18n.t('withdrawal_requests')}
                                </span>
                              </NavLink>
                            </div>
                          )}

                          {/* Groups */}
                          {(user.role === 'A' || user.role === 'F') && (
                            <NavLink
                              to="/groups"
                              activeClassName="active"
                              className="d-flex  border-bottom"
                            >
                              <span className="icon1 me-3">
                                <Layers size={16} />
                              </span>{' '}
                              {i18n.t('groups')}
                            </NavLink>
                          )}

                          {/* Admin-only */}
                          {user.role === 'A' && (
                            <NavLink
                              to="/masks"
                              activeClassName="active"
                              className="d-flex  border-bottom"
                            >
                              <span className="icon1 me-3">
                                <Layers size={16} />
                              </span>{' '}
                              {i18n.t('masks')}
                            </NavLink>
                          )}
                          {user.role === 'A' && (
                            <NavLink
                              to="/categories"
                              activeClassName="active"
                              className="d-flex  border-bottom"
                            >
                              <span className="icon1 me-3">
                                <List size={16} />
                              </span>{' '}
                              {i18n.t('categories')}
                            </NavLink>
                          )}
                          {user.role === 'A' && (
                            <NavLink
                              to="/organizations"
                              activeClassName="active"
                              className="d-flex  border-bottom"
                            >
                              <span className="icon1 me-3">
                                <Building2 size={16} />
                              </span>{' '}
                              {i18n.t('organizations')}
                            </NavLink>
                          )}
                          {user.role === 'A' && (
                            <NavLink
                              to="/banners"
                              activeClassName="active"
                              className="d-flex  border-bottom"
                            >
                              <span className="icon1 me-3">
                                <Image size={16} />
                              </span>{' '}
                              {i18n.t('banners')}
                            </NavLink>
                          )}
                          {user.role === 'A' && (
                            <NavLink
                              to="/blacklist"
                              activeClassName="active"
                              className="d-flex  border-bottom"
                            >
                              <span className="icon1 me-3">
                                <Ban size={16} />
                              </span>{' '}
                              {i18n.t('blacklist')}
                            </NavLink>
                          )}
                          {user.role === 'A' && (
                            <>
                              <NavLink
                                to="/auction/create"
                                activeClassName="active"
                                className="d-flex  border-bottom"
                              >
                                <span className="icon1 me-3">
                                  <Plus size={16} />
                                </span>{' '}
                                {i18n.t('create_auction')}
                              </NavLink>

                              <NavLink
                                to="/attributes/create"
                                activeClassName="active"
                                className="d-flex  border-bottom"
                              >
                                <ListPlus size={16} className="me-3" />
                                {i18n.t('attributes')}
                              </NavLink>
                            </>
                          )}

                          {/* Auctions List */}
                          {['A', 'C', 'PM', 'F', 'OM', 'GM', 'CE', 'M'].includes(user.role) && (
                            <NavLink
                              to="/auctions-list"
                              activeClassName="active"
                              className="d-flex  border-bottom"
                            >
                              <span className="icon1 me-3">
                                <Gavel size={16} />
                              </span>{' '}
                              {i18n.t('auctions')}
                            </NavLink>
                          )}

                          {/* Auction Approval / Supplier Payment */}
                          {['C', 'PM', 'OM', 'F'].includes(user.role) && (
                            <NavLink
                              to="/auction_approval"
                              activeClassName="active"
                              className="d-flex  border-bottom"
                            >
                              <ClipboardClock size={20} className="mx-3" />
                              {user.role === 'F'
                                ? i18n.t('supplier_payment')
                                : i18n.t('auction_approval')}
                            </NavLink>
                          )}

                          {/* Approved Auctions */}
                          {user.role === 'A' && (
                            <NavLink
                              to="/approved_auctions"
                              activeClassName="active"
                              className="d-flex  border-bottom"
                            >
                              <span className="icon1 me-3">
                                <CheckCircle size={16} />
                              </span>
                              {i18n.t('approved_auctions')}
                            </NavLink>
                          )}

                          {/* Loading Management group (HSE, PM, O, GM) */}
                          {['HSE', 'PM', 'O', 'GM'].includes(user.role) && (
                            <>
                              <NavLink
                                to="/loading-management"
                                activeClassName="active"
                                className="d-flex  border-bottom"
                              >
                                <Forklift size={16} className="me-3" />
                                {i18n.t('loading_management')}
                              </NavLink>

                              <NavLink
                                to="/vehicles"
                                activeClassName="active"
                                className="d-flex  border-bottom"
                              >
                                <Truck size={16} className="me-3" />
                                {i18n.t('vehicles')}
                              </NavLink>

                              <NavLink
                                to="/delivery-site-list"
                                activeClassName="active"
                                className="d-flex  border-bottom"
                              >
                                <List size={16} className="me-3" />
                                {i18n.t('delivery_site_list')}
                              </NavLink>

                              <NavLink
                                to="/weighbridge-ticket-list"
                                activeClassName="active"
                                className="d-flex  border-bottom"
                              >
                                <List size={16} className="me-3" />
                                {i18n.t('weighbridge_ticket_list')}
                              </NavLink>

                              <NavLink
                                to="/site-visit-projects"
                                activeClassName="active"
                                className="d-flex  border-bottom"
                              >
                                <MapPin size={16} className="me-3" />
                                {i18n.t('site_visit_projects')}
                              </NavLink>

                              <NavLink
                                to="/site-visit-requests"
                                activeClassName="active"
                                className="d-flex  border-bottom"
                              >
                                <MapPin size={16} className="me-3" />
                                {i18n.t('site_visit_req')}
                              </NavLink>
                            </>
                          )}

                          {/* Site Visit - not for C */}
                          {!['C'].includes(user.role) && (
                            <NavLink
                              activeClassName="active"
                              to="/site_visit"
                              className="d-flex  border-bottom"
                            >
                              <span className="icon1 me-3">
                                <MapPin size={16} />
                              </span>{' '}
                              {i18n.t('site_visit')}
                            </NavLink>
                          )}

                          {/* Payments */}
                          {(user.role === 'A' || user.role === 'M') && (
                            <NavLink
                              activeClassName="active"
                              to="/payments"
                              className="d-flex  border-bottom"
                            >
                              <span className="icon1 me-3">
                                <CreditCard size={16} />
                              </span>{' '}
                              {i18n.t('payment')}
                            </NavLink>
                          )}

                          {/* Client Payments */}
                          {(user.role === 'A' || user.role === 'PM' || user.role === 'OM') && (
                            <NavLink
                              activeClassName="active"
                              to="/client-payments"
                              className="d-flex  border-bottom"
                            >
                              <Landmark size={16} className="me-3" />
                              {i18n.t('client_payment')}
                            </NavLink>
                          )}

                          {/* Refund */}
                          {['A', 'PM', 'F', 'OM', 'GM', 'CE'].includes(user.role) && (
                            <NavLink
                              activeClassName="active"
                              to="/refund"
                              className="d-flex  border-bottom"
                            >
                              <Undo2 size={16} className="me-3" />
                              {i18n.t('refund')} &nbsp;
                              {allowed_roles.includes(user.role) && count > 0 && (
                                <span className="badge rounded-circle badge-notification bg-danger">
                                  {count}
                                </span>
                              )}
                            </NavLink>
                          )}

                          {/* Reports - wrapper now includes F, same as SideBar */}
                          {['A', 'C', 'PM', 'OM', 'GM', 'CE', 'M', 'F'].includes(user.role) && (
                            <div>
                              <a
                                href={true}
                                className="d-flex  border-bottom"
                                onClick={() => {
                                  this.setState({
                                    report_menu_expand: !this.state.report_menu_expand,
                                  });
                                }}
                              >
                                <span className="icon1 me-3">
                                  {this.state.report_menu_expand ? (
                                    <Minus size={16} />
                                  ) : (
                                    <Plus size={16} />
                                  )}
                                </span>
                                <span>{i18n.t('reports')}</span>
                                <span
                                  className="icon1 me-3"
                                  style={{
                                    position: 'absolute',
                                    right: lang === 'en' ? 0 : 'auto',
                                    left: lang === 'ar' ? 0 : 'auto',
                                  }}
                                ></span>
                              </a>
                              <div className={this.state.report_menu_expand ? 'm-3' : 'd-none m-3'}>
                                {['A', 'C', 'PM', 'OM', 'GM', 'CE', 'M'].includes(user.role) && (
                                  <>
                                    <NavLink
                                      activeClassName="active"
                                      to="/auction_bid_report"
                                      className="d-flex border-bottom text-danger"
                                    >
                                      <span className="icon1 me-3">
                                        <FileText size={16} />
                                      </span>{' '}
                                      {i18n.t('auction_bid_report')}
                                    </NavLink>
                                    <NavLink
                                      activeClassName="active"
                                      to="/winners"
                                      className="d-flex border-bottom text-danger"
                                    >
                                      <span className="icon1 me-3">
                                        <Flag size={16} />
                                      </span>{' '}
                                      {i18n.t('auction_winners')}
                                    </NavLink>
                                    <NavLink
                                      to="/sales_report"
                                      activeClassName="active"
                                      className="d-flex border-bottom text-danger"
                                    >
                                      <span className="icon1 me-3">
                                        <DollarSign size={16} />
                                      </span>{' '}
                                      {i18n.t('sales_report')}
                                    </NavLink>
                                    <NavLink
                                      to="/final_report"
                                      activeClassName="active"
                                      className="d-flex border-bottom text-danger"
                                    >
                                      <span className="icon1 me-3">
                                        <Hourglass size={16} />
                                      </span>{' '}
                                      {i18n.t('final_report')}
                                    </NavLink>
                                    <NavLink
                                      to="/position_report"
                                      activeClassName="active"
                                      className="d-flex border-bottom text-danger"
                                    >
                                      <span className="icon1 me-3">
                                        <Key size={16} />
                                      </span>{' '}
                                      {i18n.t('position_report')}
                                    </NavLink>
                                    <NavLink
                                      to="/reports"
                                      activeClassName="active"
                                      className="d-flex border-bottom text-danger"
                                    >
                                      <span className="icon1 me-3">
                                        <BarChart3 size={16} />
                                      </span>{' '}
                                      {i18n.t('reports')}
                                    </NavLink>
                                  </>
                                )}
                                {/* wallet_summary available to all reports-wrapper roles, incl F */}
                                <NavLink
                                  to="/wallet_summary"
                                  activeClassName="active"
                                  className="d-flex border-bottom text-danger"
                                >
                                  <span className="icon1 mx-3">
                                    <Wallet size={16} />
                                  </span>{' '}
                                  {i18n.t('wallet_summary')}
                                </NavLink>
                              </div>
                            </div>
                          )}

                          {/* Composer */}
                          {['A', 'PM', 'OM', 'GM', 'CE', 'M'].includes(user.role) && (
                            <NavLink
                              to="/composer"
                              activeClassName="active"
                              className="d-flex  border-bottom"
                            >
                              <span className="icon1 me-3">
                                <Bell size={16} />
                              </span>{' '}
                              {i18n.t('composer')}
                            </NavLink>
                          )}

                          <a
                            href={true}
                            onClick={logout}
                            style={{ cursor: 'pointer' }}
                            className="d-flex"
                          >
                            <span className="icon1 me-3">
                              <LogOut size={16} />
                            </span>{' '}
                            {i18n.t('logout')}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </React.Fragment>
    );
  }
}
